<template>
    <div class="search-spots">

        <!-- Close Button -->
        <button class="close" @click="$emit('close')">
            <svg class="close"><use xlink:href="#close"></use></svg>
        </button>

        <!-- Title -->
        <h4 class="title">
            Add a spot to this list
        </h4>

        <!-- Search Input -->
        <div class="search-input">
            <input type="text"
                   id="search-spots-input"
                   @keyup="searchSpots"
                   autocomplete="off"
                   autofocus
                   v-model="searchKey"
                   placeholder="Search spots...">
        </div>

        <!-- Live Results -->
        <div class="spot-rows" v-if="spots.length && searchKey != ''">
            <h6>Results</h6>
            <div class="results">
                <ul class="spot-row-list">
                    <li v-for="spot in spots" :key="`search-spot-${spot.id}`" class="spot-row-item">
                        <a class="item-content" :href="`/${spot.city.slug}/${spot.slug}?source-list=${list.slug}`">
                            <img :src="spot.image" :alt="spot.name">
                            <div class="info">
                                <h4 v-text="spot.name"></h4>
                                <div>
                                    <span v-text="spot.category.title"></span> in <span v-text="spot.city.title"></span>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- No Results and Empty Search Key -->
        <div class="suggestions" v-if="searchKey == ''">

            <!-- Recent Spots -->
            <RecentSpots :list="list" />

            <!-- Most Loved Spots -->
            <MostLovedSpots :list="list" />

        </div>

        <!-- No Results with dirty Search Key -->
        <div class="no-results" v-if="spots.length == 0 && searchKey != ''">

            <h5 class="title">No one has added this spot yet!</h5>
            <div class="info">Add it or modify your search.</div>

            <a :href="`/add-a-spot?source-list=${list.slug}`" class="btn-add-new-spot">
                <svg class='plus'><use xlink:href="#plus"></use></svg>
                Add a New Spot
            </a>

        </div>

    </div>
</template>
<script>

import RecentSpots from './RecentSpots'
import MostLovedSpots from './MostLovedSpots'

export default {

    props: ['list'],

    components: {
        RecentSpots,
        MostLovedSpots,
    },

    data(){
        return {
            searchKey: '',
            spots: [],
        }
    },

    mounted(){
        $('#search-spots-input').focus()
    },

    created() {
        this.searchSpots()
    },

    methods: {

        searchSpots: _.debounce(function () {
            axios.get('/search', {
                params: {
                    searchKey: this.searchKey,
                    index: 'recommendations',
                    perPage: 8,
                }
            })
                .then(response => {
                    this.spots = response.data.spots.hits;
                })
        }, 500),

    },
}
</script>
